<template>
  <div id="mainWraper">
    <div class="scaleable-wrapper" id="scaleable-wrapper">
      <div class="very-specific-design" id="very-specific-design">
        <!-- <tr-update></tr-update> -->
        <dev-sidebar :multibook-type="correctModuleName" v-if="devTool"></dev-sidebar>
        <dev-footer v-if="showDevlopmentBar"></dev-footer>
        <mb-presentation v-if="presentationState"></mb-presentation>
        <header-bar @firstPage="firstPage"></header-bar>
        <tr-canvas></tr-canvas>
        <info-message></info-message>
        <div class="bb-bookblock" v-BookBlock="options" ref="BookBlock">
          <cropp-image-with-drawing v-if="mbciwdState" @clearCanvas="clearCanvas"></cropp-image-with-drawing>
          <div class="bb-item bb-item-cover">
            <div class="page cover" :id="getPageById(0).right.id">
              <div class="page-inner-container">
                <tr-page
                  class="right icons-container"
                  :class="[
                    { 'disable-icons': canvasActive },
                    { 'disable-icons': modalActive },
                    { 'disable-icons': isModalImageActive },
                  ]"
                  :page-data="getPageById(0).right"
                >
                </tr-page>
                <div class="page-background effect8" :style="getImageSrc(getPageById(0).right)"></div>
                <!-- page corner -->
                <div
                  class="page-corners"
                  :class="[
                    { 'disable-page-corners': canvasActive },
                    { 'disable-page-corners': modalActive },
                    { 'disable-page-corners': isModalImageActive },
                  ]"
                >
                  <div class="right-top-corner corner">
                    <tr-page-corner
                      page-type="right"
                      key="right-top"
                      @previusPage="previusPage"
                      @nextPage="nextPage"
                      @clearCanvas="clearCanvas"
                    >
                    </tr-page-corner>
                  </div>
                  <div class="right-bottom-corner corner">
                    <tr-page-corner
                      page-type="right"
                      key="right-bottom"
                      @previusPage="previusPage"
                      @nextPage="nextPage"
                      @clearCanvas="clearCanvas"
                    >
                    </tr-page-corner>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="bb-item"
            :class="{ 'zoom-in-active-class': zoomInActive }"
            v-for="(page, index) in pages"
            :key="'page_' + index"
            @click="zoomInActiveArea"
          >
            <div class="page" v-if="getPageById(page.id).left" :id="getPageById(page.id).left.id">
              <div class="page-inner-container">
                <tr-page
                  class="left-page icons-container"
                  :class="[
                    { 'disable-icons': canvasActive },
                    { 'disable-icons': modalActive },
                    { 'disable-icons': isModalImageActive },
                  ]"
                  :icons="$store.getters.showIcons"
                  type="left"
                  :page-data="getPageById(page.id).left"
                >
                </tr-page>
                <div class="page-background effect8" :style="getImageSrc(getPageById(page.id).left)">
                  <!-- page corner -->
                  <div
                    class="page-corners"
                    :class="[
                      { 'disable-page-corners': canvasActive },
                      { 'disable-page-corners': modalActive },
                      { 'disable-page-corners': isModalImageActive },
                    ]"
                  >
                    <div class="left-top-corner corner">
                      <tr-page-corner
                        page-type="left"
                        key="left-top"
                        @previusPage="previusPage"
                        @nextPage="nextPage"
                        @clearCanvas="clearCanvas"
                      >
                      </tr-page-corner>
                    </div>
                    <div class="left-bottom-corner corner">
                      <tr-page-corner
                        page-type="left"
                        key="leftBootom"
                        @previusPage="previusPage"
                        @nextPage="nextPage"
                        @clearCanvas="clearCanvas"
                      >
                      </tr-page-corner>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="page" v-if="getPageById(page.id).right" :id="getPageById(page.id).right.id">
              <div class="page-inner-container">
                <div class="page-background effect8" :style="getImageSrc(getPageById(page.id).right)">
                  <!-- page corner -->
                  <div
                    class="page-corners"
                    :class="[
                      { 'disable-page-corners': canvasActive },
                      { 'disable-page-corners': modalActive },
                      { 'disable-page-corners': isModalImageActive },
                    ]"
                  >
                    <div class="right-top-corner corner">
                      <tr-page-corner
                        page-type="right"
                        key="right-top"
                        @previusPage="previusPage"
                        @nextPage="nextPage"
                        @clearCanvas="clearCanvas"
                      >
                      </tr-page-corner>
                    </div>
                    <div class="right-bottom-corner corner">
                      <tr-page-corner
                        page-type="right"
                        key="right-bootom"
                        @previusPage="previusPage"
                        @nextPage="nextPage"
                        @clearCanvas="clearCanvas"
                      >
                      </tr-page-corner>
                    </div>
                  </div>
                </div>
                <tr-page
                  class="right-page icons-container"
                  :class="[
                    { 'disable-icons': canvasActive },
                    { 'disable-icons': modalActive },
                    { 'disable-icons': isModalImageActive },
                  ]"
                  :icons="$store.getters.showIcons"
                  type="right"
                  :page-data="getPageById(page.id).right"
                >
                </tr-page>
              </div>
            </div>
          </div>
          <div class="bb-item bb-item-cover">
            <div class="page last-cover" :id="getPageById(pageLength - 1).left.id">
              <div class="page-inner-container">
                <div class="page-background effect8" :style="getImageSrc(getPageById(pageLength - 1).left)"></div>
                <div
                  class="page-corners"
                  :class="[
                    { 'disable-page-corners': canvasActive },
                    { 'disable-page-corners': modalActive },
                    { 'disable-page-corners': isModalImageActive },
                  ]"
                >
                  <div class="left-top-corner corner">
                    <tr-page-corner
                      page-type="left"
                      key="left-top"
                      @previusPage="previusPage"
                      @nextPage="nextPage"
                      @clearCanvas="clearCanvas"
                    >
                    </tr-page-corner>
                  </div>
                  <div class="left-bottom-corner corner">
                    <tr-page-corner
                      page-type="left"
                      key="left-bottom"
                      @previusPage="previusPage"
                      @nextPage="nextPage"
                      @clearCanvas="clearCanvas"
                    >
                    </tr-page-corner>
                  </div>
                </div>
                <tr-page
                  class="left icons-container"
                  :class="[
                    { 'disable-icons': canvasActive },
                    { 'disable-icons': modalActive },
                    { 'disable-icons': isModalImageActive },
                  ]"
                  :page-data="getPageById(pageLength - 1).left"
                >
                </tr-page>
              </div>
            </div>
          </div>
        </div>
        <!-- images -->
        <div
          class="image-wrapper"
          :class="[
            { 'all-top-layout-class': allTopLayoutDisable },
            { 'modal-active-class': modalActive },
            { 'canvas-active-class': canvasActive },
          ]"
          :style="'top:-' + rectangleHeight + 'px;width:' + rectangleWidth + 'px;height:' + rectangleHeight + 'px;'"
        >
          <div
            class="imagesLeft"
            :style="'width:' + topLayerWidth + 'px;height:' + topLayerHeight + 'px;'"
            v-if="getActualPage.left"
          >
            <!-- ramki left -->
            <tr-rectangle
              v-for="rectangle in getActualPage.left.rectangle"
              :key="rectangle.id"
              :data="rectangle"
              :class="[
                { 'all-top-layout-class': allTopLayoutDisable },
                { 'modal-active-class': modalActive },
                { 'canvas-active-class': canvasActive },
              ]"
              type="left"
            >
            </tr-rectangle>
            <div
              class="image"
              v-for="img in getActualPage.left.images"
              :key="img.imageId"
              :class="[
                { 'all-top-layout-class': allTopLayoutDisable },
                { 'modal-active-class': modalActive },
                { 'canvas-active-class': canvasActive },
              ]"
              :style="rectangleStyle(img, 'left')"
            >
              <button class="image-rectangle draw meet" :id="img.imageId" @click="setModalImage(img)"></button>
            </div>
          </div>
          <div
            class="images-right"
            :style="'width:' + topLayerWidth + 'px;height:' + topLayerHeight + 'px;'"
            v-if="getActualPage.right"
          >
            <!-- ramki right -->
            <tr-rectangle
              v-for="rectangle in getActualPage.right.rectangle"
              :key="rectangle.id"
              :data="rectangle"
              :class="[
                { 'all-top-layout-class': allTopLayoutDisable },
                { 'modal-active-class': modalActive },
                { 'canvas-active-class': canvasActive },
              ]"
              type="right"
            >
            </tr-rectangle>
            <div
              class="image"
              v-for="img in getActualPage.right.images"
              :key="img.imageId"
              :class="[
                { 'all-top-layout-class': allTopLayoutDisable },
                { 'modal-active-class': modalActive },
                { 'canvas-active-class': canvasActive },
              ]"
              :style="rectangleStyle(img, 'right')"
            >
              <button class="image-rectangle draw meet" :id="img.imageId" @click="setModalImage(img)"></button>
            </div>
          </div>
        </div>
        <!-- bookIndex -->
        <tr-book-index v-if="showBookIndex && showBookIndexIcon" @jumpTo="jumpTo" @clearCanvas="clearCanvas">
        </tr-book-index>
        <!-- image modal -->
        <div class="image-modal-wrapper">
          <tr-modal
            v-if="isModalImageActive"
            :class="[{ 'modal-active-class': isModalImageActive }]"
            name="modal-image"
            :width="modalWidth"
            :height="modalHeight"
            @close="closeModalImage"
          >
            <tr-image slot="body" v-if="getModalImage" :image="getModalImage"> </tr-image>
          </tr-modal>
        </div>
        <!-- Footer -->
        <footer-navi
          key="footerNavi"
          class="fixed-bottom"
          :class="[{ 'modal-active-class': modalActive }, { 'footer-navi-modal-image-chage': isModalImageActive }]"
          @firstPage="firstPage"
          @previusPage="previusPage"
          @jumpTo="jumpTo"
          @nextPage="nextPage"
          @lastPage="lastPage"
          @clearCanvas="clearCanvas"
        >
        </footer-navi>
      </div>
    </div>
    <!-- zoomIn modal -->
    <tr-zoom-in name="modal-zoomIn" v-if="showZoomIn" :width="modalWidth" :height="modalHeight" :area="area">
      <div class="modal-body-flex" slot="body">
        <div class="free dragscroll" :class="{ 'dragscroll-zoom-in-active': zoomInActive }">
          <div
            class="zoom-in-centerfold"
            :style="'width:' + zoomInCenterfold.width + 'px;' + 'height:' + zoomInCenterfold.height + 'px;'"
          >
            <img draggable="false" :src="getImageLeft()" class="zoom-in-page-left" alt="" />
            <img draggable="false" :src="getImageRight()" class="zoom-in-page-right" alt="" />
          </div>
        </div>
      </div>
    </tr-zoom-in>
    <!-- galleryZoom modal -->
    <tr-zoom-in
      name="modal-gallery-zoom"
      class="modal-gallery-zoom"
      v-if="imageZoomActive"
      :width="modalWidth"
      :height="modalHeight"
      :area="area"
    >
      <div class="modal-body-flex" slot="body">
        <div class="free dragscroll">
          <div
            class="zoom-in-centerfold"
            :style="
              imageZoomData.width <= 1920
                ? 'height:1080px;margin:auto;justify-content:center;'
                : 'height:1080px;margin:auto;'
            "
          >
            <img
              draggable="false"
              :src="imageZoomData.src"
              style="height: 1080px; margin-left: auto; margin-right: auto"
              alt=""
            />
          </div>
        </div>
      </div>
    </tr-zoom-in>
    <!-- new Game element -->
    <tr-modal
      class="modal-game-container"
      v-if="gameActive"
      @close="close('showModalGame')"
      :width="modalWidth"
      :height="modalHeight"
    >
      <tr-game-v2 slot="body" v-if="gameEngineVersion === 'v2'"> </tr-game-v2>
      <tr-game slot="body" v-else> </tr-game>
    </tr-modal>
    <!-- start Demo Message -->
    <div class="demo-message">
      <tr-demo-messages v-if="showDemoMessage" @close="closeDemoMessage"></tr-demo-messages>
    </div>
    <!-- end Demo Message -->
  </div>
</template>
<script>
import TrRectangle from '../TrPage/TrRectangle/TrRectangle';
import TrPage from '../TrPage/TrPage';
import FooterNavi from '../FooterNavi/FooterNavi';
import HeaderBar from '../HeaderBar/HeaderBar';
import TrCanvas from '../FooterNavi/SubComponents/TrCanvas';
import TrModal from '../TrModal/TrModal';
import TrZoomIn from '../TrZoomIn/TrZoomIn';
import TrImage from '../TrPage/TrImage/TrImage';
import TrBookIndex from '__mainSrcDir/bookIndex/TrBookIndex';
import TrPageCorner from '../TrPageCorner/TrPageCorner';
import MobileOrientation from '__mainSrcDir/Utils/Mobile/MobileOrientation/MobileOrientation';
import DevFooter from '__mainSrcDir/Utils/DevFooter/DevFooter';
import DevSidebar from '__mainSrcDir/Utils/DevSidebar/DevSidebar';
import InfoMessage from '__mainSrcDir/Utils/InfoMessage/InfoMessage';
import TrDemoMessages from '__mainSrcDir/Utils/InfoMessage/TrDemoMessages';
// import TrUpdate from '../TrUpdate/TrUpdate';
import TrGameV2 from '__mainSrcDir/components/TrGame/v2/TrGameV2';
import TrGame from '__mainSrcDir/components/TrGame/v4/TrGame';
import $ from 'jquery';
import _ from 'lodash';
import { log } from 'util';
import MbPresentation from '../MbPresentation/MbPresentation.vue';
import CroppImageWithDrawing from '../CroppImage/CroppImageWithDrawing.vue';

const multibookConfig = require(`__rootDir/package.json`).config;

require('dragscroll');
if (!process.env.VUE_APP_IS_WEB) {
  // const { ipcRenderer } = require('electron');
} else {
  console.log('WEB ipcRenderer');
}

export default {
  name: 'main-view',
  props: {
    pageNumber: {
      type: null,
      default: '-1',
    },
    multibookType: {
      type: String,
      default: multibookConfig.type,
    },
  },
  data: function () {
    return {
      modalWidth: 100,
      modalHeight: 100,
      options: {
        speed: 500,
      },
    };
  },
  components: {
    TrRectangle,
    TrPage,
    FooterNavi,
    HeaderBar,
    TrCanvas,
    TrModal,
    TrZoomIn,
    TrImage,
    TrBookIndex,
    TrPageCorner,
    DevFooter,
    DevSidebar,
    InfoMessage,
    TrDemoMessages,
    // TrUpdate,
    TrGame,
    TrGameV2,
    MbPresentation,
    CroppImageWithDrawing,
  },
  beforeRouteEnter(to, from, next) {
    if (to.name === 'main-view' && _.isNumber(to.params.id)) {
      next((vm) => {
        let index = to.params.id;
        vm.jumpTo(index);
      });
    } else if (to.name === 'page-view' && _.isNumber(parseInt(to.params.id))) {
      next((vm) => {
        let findPage;
        let index = parseInt(to.params.id);
        if (_.isNumber(index)) {
          findPage = _.find(vm.$store.getters[`${vm.correctModuleName}/getAllPages`], (doublePage) => {
            if (
              (doublePage.left && doublePage.left.id === index) ||
              (doublePage.right && doublePage.right.id === index)
            ) {
              return true;
            }
          });
          if (index <= -1) {
            vm.$store.commit(`${vm.correctModuleName}/CHANGE_ACTUAL_PAGE`, 0);
            vm.bookblock.first();
          } else if (findPage && findPage.id !== vm.$store.getters[`${vm.correctModuleName}/getActualPage`].id) {
            vm.$store.commit(`${vm.correctModuleName}/CHANGE_ACTUAL_PAGE`, findPage.id);
            vm.bookblock.jump(findPage.id + 1);
          } else if (findPage && findPage.id === vm.$store.getters[`${vm.correctModuleName}/getActualPage`].id) {
            vm.bookblock.jump(findPage.id + 1);
          } else {
            console.log('Not a number');
          }
        } else {
          console.log('Page not exist');
        }
      });
    } else {
      next();
    }
  },
  beforeRouteUpdate(to, from, next) {
    let index = parseInt(to.params.id);
    let findPage = null;
    if (_.isNumber(index)) {
      findPage = _.find(this.$store.getters[`${this.correctModuleName}/getAllPages`], (doublePage) => {
        if ((doublePage.left && doublePage.left.id === index) || (doublePage.right && doublePage.right.id === index)) {
          return true;
        }
      });
      if (index <= -1) {
        this.$store.commit(`${this.correctModuleName}/CHANGE_ACTUAL_PAGE`, 0);
        this.bookblock.first();
      } else if (findPage && findPage.id !== this.$store.getters[`${this.correctModuleName}/getActualPage`].id) {
        this.$store.commit(`${this.correctModuleName}/CHANGE_ACTUAL_PAGE`, findPage.id);
        this.bookblock.jump(findPage.id + 1);
      } else if (findPage && findPage.id === this.$store.getters[`${this.correctModuleName}/getActualPage`].id) {
        this.bookblock.jump(findPage.id + 1);
      } else {
        console.log('Not a number');
      }
    }
    next();
  },
  beforeDestroy: function () {
    console.log('Destroy Event');
    let that = this;
    window.removeEventListener('keyup', this.key, true);
    window.removeEventListener('cache-outdate', function (e) {
      that.$store.commit('CHANGE_CACHE_STATUS', true);
    });
  },
  mounted: function () {
    if (this.multibookType) {
      this.$store.commit('CHANGE_MULTIBOOK_TYPE', this.multibookType);
    } else {
      this.$store.commit('CHANGE_MULTIBOOK_TYPE', multibookConfig.type);
    }
    let $innerWindow = $('#scaleable-wrapper');
    let $el = $('#very-specific-design');
    let $mainContent = $('#mainContent');
    let $bbBlock = $('.bb-bookblock');
    let $naviWrapper = $('.navi-wrapper');
    let $page = $('.page');
    let $cover = $('.cover');
    let myCanvas = $('#myCanvas');
    let textMarkerCanvas = $('#textMarkerCanvas');
    let tempCanvas = $('#tempCanvas');
    function doResize() {
      let scale;
      scale = Math.min($innerWindow.width() / $el.outerWidth(), $innerWindow.height() / $el.outerHeight());
      $el.css({
        transform: 'translate(-50%, -50%) ' + 'scale(' + scale + ')',
        '-webkit-transform-origin': 'center center',
        '-webkit-font-smoothing': 'subpixel-antialiased',
        'backface-visibility': 'hidden',
        position: 'absolute',
        top: '50vh',
      });
      let mainContenWidth = this.$store.getters.mainContenWidth;
      let mainContenHeight = this.$store.getters.mainContenHeight;
      let mainContenPadding = 0;
      $mainContent.css({
        height: mainContenHeight,
        paddingLeft: mainContenPadding,
        paddingRight: mainContenPadding,
      });
      $page.css({
        width: mainContenWidth,
        height: mainContenHeight,
        paddingLeft: mainContenPadding,
        paddingRight: mainContenPadding,
        '-webkit-font-smoothing': 'subpixel-antialiased',
        'backface-visibility': 'hidden',
      });
      $bbBlock.css({
        width: mainContenWidth * 2,
        height: mainContenHeight,
        '-webkit-font-smoothing': 'subpixel-antialiased',
        'backface-visibility': 'hidden',
      });
      $naviWrapper.css({
        width: mainContenWidth * 2,
        '-webkit-font-smoothing': 'subpixel-antialiased',
        'backface-visibility': 'hidden',
      });
      $cover.css({
        width: mainContenWidth,
        height: mainContenHeight,
        '-webkit-font-smoothing': 'subpixel-antialiased',
        'backface-visibility': 'hidden',
      });
      this.$store.commit('CHANGE_SCALE', scale);
      this.$store.commit('MY_CANVAS', myCanvas);
      this.$store.commit('TEXT_MARKER_CANVAS', textMarkerCanvas);
      this.$store.commit('TEMP_CANVAS', tempCanvas);
      this.$store.commit('CHANGE_CANVAS_HEIGHT', mainContenHeight);
      this.$store.commit('CHANGE_CANVAS_WIDTH', ((mainContenWidth * 90) / 100) * 2);
      this.$store.commit('CHANGE_CANVAS_TOP', $bbBlock.position().top);
      this.$store.commit('CHANGE_CANVAS_LEFT', $bbBlock.position().left);
      this.$store.commit('CHANGE_BACKUP_CANVAS_HEIGHT', mainContenHeight);
      this.$store.commit('CHANGE_BACKUP_CANVAS_WIDTH', ((mainContenWidth * 90) / 100) * 2);
      this.$store.commit('CHANGE_BACKUP_CANVAS_TOP', $bbBlock.position().top);
      this.$store.commit('CHANGE_BACKUP_CANVAS_LEFT', $bbBlock.position().left);
    }
    let resize = doResize.bind(this);
    let starterData = {
      size: {
        width: $innerWindow.width(),
        height: $innerWindow.height(),
      },
    };
    resize(null, starterData);
    window.addEventListener('keyup', this.key, true);
    // service worker cache event listener
    let that = this;
    window.addEventListener('cache-outdate', function (e) {
      that.$store.commit('CHANGE_CACHE_STATUS', true);
    });
    window.addEventListener('cache-updated', function (e) {
      that.$store.commit('CHANGE_CACHE_STATUS', false);
    });
  },
  methods: {
    checkGameEngine() {
      if (this.gameData.item) {
        // console.log(this.gameData.item);
        if (this.gameData.item.engine == 'croppImg') {
          return false;
        } else return true;
      } else return true;
    },
    key(e) {
      /**
       * obsluga klawiatury
       * @method switch
       * @param  {event} e event
       */
      if (this.mbciwdState) {
        switch (e.keyCode) {
          case 27:
            this.$store.commit('CHANGE_MBCIWD_ACTIVE', false);
            this.$store.commit('CHANGE_MBCIWD_CONFIG', {});
            this.$store.commit('CHANGE_MBCIWD_ACTIVE', false);
            this.$store.commit('TOGGLE_CANVAS');
            this.$store.commit('TOGGLE_CANVAS_TOOLBOX');
            this.$store.commit('TOGGLE_CANVAS_TEXT_MARKER', false);
            this.$store.commit('TOGGLE_UI_DISABLE', false);
            this.clearCanvas();
            break;
        }
      }
      if (
        !this.modalActive &&
        !this.isModalImageActive &&
        !this.inputFocus &&
        !this.gameActive &&
        !this.showDemoMessage
      ) {
        switch (e.keyCode) {
          case 27:
            // this.$electron.remote.getCurrentWindow().setFullScreen(false);
            this.$store.commit('TOGGLE_FULL_SCREEN_ACTIVE', false);
            break;
          case 37:
            this.clearCanvas();
            this.previusPage();
            break;
          case 39:
            this.clearCanvas();
            this.nextPage();
            break;
        }
      }
      if (this.zoomInActive) {
        switch (e.keyCode) {
          case 27:
            this.$store.commit('SHOW_ZOOMIN', false);
            this.$store.commit('ZOOMIN_ACTIVE', false);
            this.$store.commit('TOGGLE_UI_DISABLE', false);
            this.$store.commit('IMAGE_ZOOM_DEACTIVATE');
            break;
        }
      }
      if (this.gameActive) {
        switch (e.keyCode) {
          case 27:
            this.$store.dispatch('closeGame');
            break;
        }
      }
      if (this.scratchActive) {
        switch (e.keyCode) {
          case 27:
            this.$store.commit('CHANGE_SCRATCH_ACTIVE', false);
            this.$store.commit('CHANGE_SCRATCH_CONTENT', false);
            $('.close-button')[0].click();
            break;
        }
      }
      if (this.wordActive) {
        switch (e.keyCode) {
          case 27:
            $('.close-button')[0].click();
            break;
        }
      }
      if (this.paintActive) {
        switch (e.keyCode) {
          case 27:
            $('.close-button')[0].click();
            break;
        }
      }
      if (this.powerpointActive) {
        switch (e.keyCode) {
          case 27:
            $('.close-button')[0].click();
            break;
        }
      }
      if (this.galleryActive && !this.isModalImageActive && !this.inputFocus) {
        let $elem = {};
        let src = {};
        let width = {};
        let height = {};
        switch (e.keyCode) {
          case 13:
            $elem = $('.pgwSlideshow').find('.ps-current  li:visible img');
            src = $elem.attr('src');
            width = $elem.prop('naturalWidth');
            height = $elem.prop('naturalHeight');
            // console.log( $elem );
            this.$store.commit('IMAGE_ZOOM_ACTIVATE');
            this.$store.commit('CHANGE_IMAGE_ZOOM_CONTENT', {
              src,
              width,
              height,
            });
            break;
          case 37:
            if (!this.$store.getters.imageZoomActive && this.$store.getters.galleryEngin.getCurrentSlide() > 1) {
              this.$store.getters.galleryEngin.previousSlide();
            }
            break;
          case 39:
            if (
              !this.$store.getters.imageZoomActive &&
              this.$store.getters.galleryEngin.getCurrentSlide() + 1 <= this.$store.getters.galleryEngin.getSlideCount()
            ) {
              this.$store.getters.galleryEngin.nextSlide();
            }
            break;
          case 27:
            this.$store.commit('SHOW_ZOOMIN', false);
            this.$store.commit('ZOOMIN_ACTIVE', false);
            this.$store.commit('TOGGLE_UI_DISABLE', false);
            if (this.$store.getters.imageZoomActive) {
              this.$store.commit('IMAGE_ZOOM_DEACTIVATE');
            } else {
              $('.close-button')[0].click();
            }
            break;
        }
      }
      if (this.isModalImageActive && !this.modalActive) {
        switch (e.keyCode) {
          case 27:
            this.closeModalImage();
            this.$store.commit('TOGGLE_UI_DISABLE', false);
            break;
        }
      }
      if ((this.modalActive && this.filmActive) || (this.modalActive && this.audioActive)) {
        switch (e.keyCode) {
          case 27:
            // console.log($(".jp-restore-screen").length);
            // console.log($(".jp-state-full-screen").length);
            if (!this.fullScreenFilmActive) {
              $('.close-button')[0].click();
            }
            break;
        }
      }
    },
    // fullScreenOff( e ) {
    //   /**
    //    * czy ESC
    //    * @method if
    //    * @param  {event} e key event
    //    */
    //   if( e.keyCode === 27 ) {
    //     this.$electron.remote.getCurrentWindow().setFullScreen( false );
    //     this.$store.commit( 'TOGGLE_FULL_SCREEN_ACTIVE', false );
    //   }
    // },
    firstPage() {
      if (this.$route.path != '/page/-1') {
        this.$store.commit(`${this.correctModuleName}/FIRST_PAGE`);
        console.log('firstPage ~ this.$route', this.$route);
        this.$router.push({ name: 'page-view', params: { id: '-1', multibookType: `${this.multibookType}` } });
      }
    },
    previusPage() {
      if (this.prevExist) {
        this.$store.commit(`${this.correctModuleName}/PREVIUS_PAGE`);
        let test = this.$store.getters[`${this.correctModuleName}/getActualPageIndex`];
        console.log(
          'this.$store.getters[`${this.correctModuleName}/getPreviusIndex`]',
          this.$store.getters[`${this.correctModuleName}/getPreviusIndex`]
        );
        if (this.$store.getters[`${this.correctModuleName}/getPreviusIndex`] === 0) {
          this.$router.push({
            name: 'page-view',
            params: {
              id: `${this.$store.getters[`${this.correctModuleName}/getPageById`](test).right.id}`,
              multibookType: `${this.multibookType}`,
            },
          });
        } else {
          this.$router.push({
            name: 'page-view',
            params: {
              id: `${this.$store.getters[`${this.correctModuleName}/getPageById`](test).left.id}`,
              multibookType: `${this.multibookType}`,
            },
          });
        }
      }
    },
    jumpTo(id) {
      this.$router.push({ name: 'page-view', params: { id: `${id}`, multibookType: `${this.multibookType}` } });
    },
    nextPage() {
      if (this.nextExist) {
        this.$store.commit(`${this.correctModuleName}/NEXT_PAGE`);
        let test = this.$store.getters[`${this.correctModuleName}/getActualPageIndex`];
        if (
          this.$store.getters[`${this.correctModuleName}/getNextIndex`] ===
          this.$store.getters[`${this.correctModuleName}/getLastPageIndex`]
        ) {
          this.$router.push({
            name: 'page-view',
            params: {
              id: `${this.$store.getters[`${this.correctModuleName}/getPageById`](test).left.id}`,
              multibookType: `${this.multibookType}`,
            },
          });
        } else {
          this.$router.push({
            name: 'page-view',
            params: {
              id: `${this.$store.getters[`${this.correctModuleName}/getPageById`](test).right.id - 1}`,
              multibookType: `${this.multibookType}`,
            },
          });
        }
      }
    },
    lastPage() {
      this.$store.commit(`${this.correctModuleName}/LAST_PAGE`);
      let test = this.$store.getters[`${this.correctModuleName}/getActualPageIndex`];
      this.$router.push({
        name: 'page-view',
        params: {
          id: `${this.$store.getters[`${this.correctModuleName}/getPageById`](test).left.id}`,
          multibookType: `${this.multibookType}`,
        },
      });
    },
    clearCanvas() {
      let myCanvas = this.$store.getters.myCanvas[0];
      let ctx = myCanvas.getContext('2d');
      let textMarkerCanvas = this.$store.getters.textMarkerCanvas[0];
      let textCtx = textMarkerCanvas.getContext('2d');
      ctx.clearRect(0, 0, myCanvas.width, myCanvas.height);
      textCtx.clearRect(0, 0, textMarkerCanvas.width, textMarkerCanvas.height);
    },
    bookIndex() {
      console.log('Show bookIndex');
    },
    getImageLeft() {
      return require(`__staticDir/${this.multibookType}/${this.getActualPage.left.imageSrc}`);
    },
    getImageRight() {
      return require(`__staticDir/${this.multibookType}/${this.getActualPage.right.imageSrc}`);
    },
    zoomInActiveArea(event) {
      let calcWidth = parseInt((event.clientX * 100) / event.view.innerWidth);
      let calcHeight = parseInt((event.clientY * 100) / event.view.innerHeight);
      let zoomCenterPoint = {
        x: calcWidth - this.zoomRadius.x - 10,
        y: calcHeight - this.zoomRadius.y - 10,
      };
      if (this.zoomInActive) {
        this.$store.commit('SET_AREA', zoomCenterPoint);
        this.$store.commit('SHOW_ZOOMIN', true);
      }
    },
    imgRectangleProcess(
      rect,
      type,
      boxSize = {
        width: parseInt(this.realWidth),
        height: parseInt(this.realHeight),
      }
    ) {
      let newRect = _.cloneDeep(rect);
      newRect.x += this.rectangleOffset.x;
      newRect.y += this.rectangleOffset.y;
      newRect.width += this.rectangleOffset.width;
      newRect.height += this.rectangleOffset.height;
      newRect.x = newRect.x < 0 ? 0 : newRect.x;
      newRect.x = newRect.x > boxSize.width ? boxSize.width : newRect.x;
      newRect.y = newRect.y < 0 ? 0 : newRect.y;
      newRect.y = newRect.y > boxSize.height ? boxSize.height : newRect.y;
      newRect.width = newRect.width > boxSize.width ? boxSize.width : newRect.width;
      newRect.height = newRect.height > boxSize.height ? boxSize.height : newRect.height;
      let x = ((newRect.x > boxSize.width ? boxSize.width : newRect.x) * 100) / boxSize.width;
      let y = ((newRect.y > boxSize.height ? boxSize.height : newRect.y) * 100) / boxSize.height;
      let width = ((newRect.width > boxSize.width ? boxSize.width : newRect.width) * 100) / boxSize.width;
      let height = ((newRect.height > boxSize.height ? boxSize.height : newRect.height) * 100) / boxSize.height;
      return {
        x,
        y,
        width,
        height,
      };
    },
    setModalImage(value) {
      if (value) {
        this.clearCanvas();
        this.$store.commit('ACTIVATE_MODALIMAGE');
        this.$store.commit('CHANGE_MODALIMAGE_CONTENT', value);
      } else {
        this.$store.commit('DEACTIVATE_MODALIMAGE');
      }
    },
    getImageSrc(data) {
      if (data && data.imageSrc) {
        let imageSrc = data.imageSrc;
        return {
          'background-image': `url("${require(`__staticDir/${this.multibookType}/${imageSrc}`)}")`,
        };
      }
    },
    closeModalImage() {
      this.$store.commit('DEACTIVATE_MODALIMAGE');
      if (this.canvasActive) {
        this.$store.commit('TOGGLE_CANVAS');
        this.$store.commit('TOGGLE_CANVAS_TOOLBOX');
        this.$store.commit('TOGGLE_CANVAS_TEXT_MARKER', false);
        this.$store.commit('TOGGLE_UI_DISABLE', false);
      }
      this.$store.commit('CHANGE_MODALIMAGE_CONTENT', '');
      this.clearCanvas();
      this.$store.commit('CHANGE_CANVAS_HEIGHT', this.$store.getters.backupCanvasHeight);
      this.$store.commit('CHANGE_CANVAS_WIDTH', this.$store.getters.backupCanvasWidth);
      this.$store.commit('CHANGE_CANVAS_TOP', this.$store.getters.backupCanvasTop);
      this.$store.commit('CHANGE_CANVAS_LEFT', this.$store.getters.backupCanvasLeft);
    },
    closeDemoMessage() {
      this.$store.commit('CHANGE_DEMO_ACTIVE', false);
    },
    // alert
    closeAlert() {
      this.showUpdateMessage = false;
    },
    showAlert() {
      // console.log( 'showAlert' );
      this.$root.$emit('show::modal', 'updaterModal');
      // this.showUpdateMessage = true;
    },
    showSpinner() {
      // this.$store.commit( 'CHANGE_SPINER_STATUS', true );
      // this.$store.getters.spinnerStatus;
    },
    hideSpinner() {
      // console.log( 'hide' );
      // this.$store.commit( 'CHANGE_SPINER_STATUS', false );
    },
    gameStart() {
      this.$router.push({
        name: 'tr-game',
      });
    },
    rectangleStyle(img, type) {
      return {
        top: `${this.imgRectangleProcess(img.rectangle, type).y.toFixed(2)}%`,
        left: `${this.imgRectangleProcess(img.rectangle, type).x.toFixed(2)}%`,
        width: `${this.imgRectangleProcess(img.rectangle, type).width.toFixed(2)}%`,
        height: `${this.imgRectangleProcess(img.rectangle, type).height}%`,
      };
    },
  },
  computed: {
    gameData() {
      return this.$store.getters.gameData;
    },
    bookblock() {
      let that = this;
      /* eslint-disable  */
      this.$refs.BookBlock.bookblock.options = _.extend(this.$refs.BookBlock.bookblock.options, {
        startPage: 1,
        speed: 1000,
        shadows: true,
        easing: 'ease-in-out',
        onBeforeFlip: function (page) {
          that.$store.commit('TOGGLE_MODAL_ACTIVE', true);
          return false;
        },
        onEndFlip: function (page, isLimit) {
          that.$store.commit('TOGGLE_MODAL_ACTIVE', false);
          return false;
        },
      });
      return this.$refs.BookBlock.bookblock;
      /* eslint-enable  */
    },
    correctModuleName() {
      const name = this.multibookType.charAt(0).toUpperCase() + this.multibookType.slice(1);
      return name;
    },
    getPageById() {
      return this.$store.getters[`${this.correctModuleName}/getPageById`];
    },
    pages() {
      return this.$store.getters[`${this.correctModuleName}/getPages`];
    },
    pageLength() {
      return this.$store.getters[`${this.correctModuleName}/pageLength`];
    },
    leftPageData() {
      return this.$store.getters[`${this.correctModuleName}/getActualPage`].left;
    },
    rightPageData() {
      return this.$store.getters[`${this.correctModuleName}/getActualPage`].right;
    },
    getActualPage() {
      return this.$store.getters[`${this.correctModuleName}/getActualPage`];
    },
    canvasActive() {
      return this.$store.getters.canvasActive;
    },
    // dane dla ramek
    rectangleWidth() {
      return ((this.$store.getters.mainContenWidth * this.$store.getters.mainContenPageCapacity) / 100) * 2;
    },
    rectangleHeight() {
      return this.$store.getters.canvasHeight;
    },
    rectangleTop() {
      return this.$store.getters.canvasTop;
    },
    rectangleLeft() {
      return this.$store.getters.canvasLeft;
    },
    allTopLayoutDisable() {
      return this.$store.getters.allTopLayoutDisable;
    },
    showZoomIn() {
      return this.$store.getters.showZoomIn;
    },
    zoomInActive() {
      return this.$store.getters.zoomInActive;
    },
    area() {
      return this.$store.getters.area;
    },
    zoomRadius() {
      return this.$store.getters.zoomRadius;
    },
    zoomInCenterfold() {
      return {
        width: this.$store.getters.zoomInCenterfoldWidth * this.$store.getters.scale + 100,
        height: this.$store.getters.zoomInCenterfoldHeight,
      };
    },
    realWidth: function () {
      return this.$store.getters.realWidth;
    },
    realHeight: function () {
      return this.$store.getters.realHeight;
    },
    isModalImageActive() {
      return this.$store.getters.isModalImageActive;
    },
    modalActive() {
      return this.$store.getters.modalActive;
    },
    galleryActive() {
      return this.$store.getters.galleryActive;
    },
    scratchActive() {
      return this.$store.getters.scratchActive;
    },
    inputFocus() {
      return this.$store.getters.inputFocus;
    },
    topLayerWidth() {
      return (this.$store.getters.mainContenWidth * this.$store.getters.mainContenPageCapacity) / 100;
    },
    topLayerHeight() {
      return this.$store.getters.mainContenHeight;
    },
    rectangleOffset() {
      return this.$store.getters.rectangleOffset;
    },
    showBookIndex() {
      return this.$store.getters.showBookIndex;
    },
    showBookIndexIcon() {
      return this.$store.getters[`${this.correctModuleName}/showBookIndexIcon`];
    },
    getModalImage() {
      return this.$store.getters.modalImage;
    },
    nextExist() {
      return this.$store.getters[`${this.correctModuleName}/nextExist`];
    },
    prevExist() {
      return this.$store.getters[`${this.correctModuleName}/prevExist`];
    },
    imageZoomData() {
      return this.$store.getters.imageZoomData;
    },
    imageZoomActive() {
      return this.$store.getters.imageZoomActive;
    },
    filmActive() {
      return this.$store.getters.filmActive;
    },
    audioActive() {
      return this.$store.getters.audioActive;
    },
    wordActive() {
      return this.$store.getters.wordActive;
    },
    paintActive() {
      return this.$store.getters.paintActive;
    },
    powerpointActive() {
      return this.$store.getters.powerpointActive;
    },
    fullScreenFilmActive() {
      return this.$store.getters.fullScreenFilmActive;
    },
    /**
     * zmienna okreslająca czy gra ma byc wyswietlona
     * @method gameActive
     * @return {Boolean}   jeśli true gra jest wyświelana (default false)
     */
    gameActive() {
      return this.$store.getters.gameActive;
    },
    showDevlopmentBar() {
      return this.$store.getters.showDevlopmentBar;
    },
    showDemoMessage() {
      return this.$store.getters.demoMessage;
    },
    presentationState() {
      return this.$store.getters.getPresentationState;
    },
    mbciwdState() {
      return this.$store.getters.mbciwdActive;
    },
    gameEngineVersion() {
      return this.$store.getters.gameEngineVersion;
    },
    devTool() {
      return this.$store.getters.devTool;
    },
  },
};
</script>

<style lang="scss">
@import '~@/assets/sass/variable';
@import '~@/assets/sass/pageCorner';
@import '~@/assets/sass/main';
.bb-bookblock {
  perspective: 18000px !important;
}

.page {
  width: 50%;
  float: left;
  height: 100%; // padding: 5%;
  box-sizing: border-box; // border: 1px solid $devBorderColor;
}

.page + .page {
  border-left: 0;
}

nav {
  margin-top: 1em;
}

.cover {
  width: 50%;
  margin-left: auto;
  float: none;
  background-size: contain;
  background-repeat: no-repeat;
  padding: 0;
  height: 100%;
}
.last-cover {
  width: 50%;
  margin-right: auto;
  float: none;
  background-size: contain;
  background-repeat: no-repeat;
  padding: 0;
  height: 100%;
}
.bb-item {
  background-color: $mainColor !important;
}

.bb-item-cover {
  background-color: transparent !important;
}

.bb-content {
  background-color: transparent !important;
}

body {
  background: #ccc;
}

.scaleable-wrapper {
  resize: both;
  position: relative;
  background: $offScaleColor;
  height: 100vh;
  z-index: 8;
  overflow-y: hidden;
  overflow-x: hidden;
  .very-specific-design {
    width: 1920px;
    height: 1080px;
    padding: 5px;
    text-align: center;
    background: $mainColor;
    position: relative;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    transform-origin: center center;
  }
}

.mainContent {
  display: flex;
  flex-direction: row;
  // height: 2278px;
  justify-content: center;
}

.page-inner-container {
  display: flex;
  height: 100%;
  width: 100%;
  .icons-container {
    pointer-events: auto;
    width: $borderIconPadding;
  }
  .page-background {
    background-size: contain;
    background-repeat: no-repeat;
    padding: 0;
    height: 100%;
    width: 100%;
  }
  .effect8 {
    position: relative;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 0 40px rgba(0, 0, 0, 0.1) inset;
  }
  .effect8:after,
  .effect8:before {
    content: '';
    position: absolute;
    z-index: -1; // box-shadow: 0 0 20px rgba(0,0,0,0.8);
    box-shadow: 3px 6px 20px rgba(0, 0, 0, 0.8);
    top: 10px;
    bottom: 10px;
    left: 0;
    right: 0;
    border-radius: 100px / 10px;
  }
  .effect8:after {
    right: 10px;
    left: auto;
    transform: skew(8deg) rotate(3deg);
  }
}

.left-page {
  background-position: right;
  margin-right: 0;
  padding-right: 0;
}

.right-page {
  background-position: left;
  margin-left: 0;
  padding-left: 0;
  position: relative;
  top: 0;
  left: 0;
  z-index: 100;
}

.button-activator {
  cursor: pointer;
  outline: none;
  background-color: transparent;
  padding: 0;
  border: none;
}

.image-wrapper {
  margin: 0 auto;
  position: relative;
  z-index: 9999;
  display: flex;
  justify-content: center;
  pointer-events: none;
  .images-right,
  .imagesLeft {
    pointer-events: none;
    position: relative;
    padding-left: 0;
    padding-right: 0;
    float: left;
    margin: 0 !important;
    .image {
      position: absolute;
      z-index: 190;
      transition: box-shadow 0.3s ease-out;
      cursor: pointer;
      pointer-events: auto;
      .image-rectangle {
        width: 100%;
        height: 100%;
        cursor: pointer;
        outline: none;
        background-color: transparent;
        border: none;
        box-shadow: none;
        background: url('~@/assets/icons/book/zoom/powiekszGrafike.png');
        opacity: 0;
        background-repeat: no-repeat;
        background-position: center;
        transition: all 0.3s ease-in;
        &:hover {
          opacity: 0.8;
          background: url('~@/assets/icons/book/zoom/powiekszGrafike.png');
          background-repeat: no-repeat;
          background-position: center; // box-shadow: inset 0 0 10px rgb(0, 0, 0);
          // background-color: rgba(36, 35, 35, 0.67);
        }
      }
      .ps-current {
        height: $modalImagesHeight !important;
        ul {
          height: 100%;
          li {
            display: flex !important;
            justify-content: center !important;
            align-content: center !important;
            height: 100% !important;
          }
        }
      }
    }
  }
  .borderHover {
    border: $borderWidth solid $borderColor;
    background-color: $rectangleHoverBackgroundColor;
  }
}

.dragscroll {
  height: 93vh;
  margin: auto;
  overflow: hidden;
  .zoom-in-centerfold {
    background-size: cover;
    background-repeat: no-repeat;
    display: flex;
    cursor: -webkit-grab;
    .zoom-in-page-left,
    .zoom-in-page-right {
      height: 100%;
      cursor: -webkit-grab;
    }
  }
}
.modal-gallery-zoom {
  .dragscroll {
    height: 99vh;
    margin: auto;
    overflow: hidden;
    .zoom-in-centerfold {
      background-size: cover;
      background-repeat: no-repeat;
      display: flex;
      cursor: -webkit-grab;
      .zoom-in-page-left,
      .zoom-in-page-right {
        height: 100%;
        cursor: -webkit-grab;
      }
    }
  }
}
.all-top-layout-class,
.canvas-active-class {
  pointer-events: none;
  display: none !important;
}
.modal-active-class {
  pointer-events: none !important;
}
.naviElementHide {
  display: none !important;
}
.footer-navi-modal-image-chage {
  z-index: 1001 !important;
  width: 100%;
}
.zoom-in-active-class {
  cursor: zoom-in;
}
.dragscroll-zoom-in-active {
  height: 100vh !important;
  padding-bottom: 40px !important;
  padding-top: 5px !important;
}
/*styl dla animacj przewracania strony - fix:widoczna ostatnia strona na srodku  */
.bb-front {
  .bb-outer {
    .bb-content {
      background: $mainColor !important;
    }
  }
}
/*styl dla animacj przewracania strony - fix:widoczna ostatnia strona na srodku  */
.bb-back {
  .bb-outer {
    .bb-content {
      background: $mainColor !important;
    }
  }
}
</style>
